import { CUSTOM_OPTION } from "./types";
import { OtherRow } from "./OtherRow";

interface RadioListInputProps {
    options: string[];
    selected: string[];
    customText: string;
    radioName: string;
    onChange: (selected: string[], customText: string) => void;
}

export function RadioListInput({ options, selected, customText, radioName, onChange }: RadioListInputProps) {
    const isCustomSelected = selected.includes(CUSTOM_OPTION);

    return (
        <>
            <div className="space-y-1.5">
                {options.map((option) => (
                    <label
                        key={option}
                        className={`flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-2.5 text-sm transition-colors ${
                            selected.includes(option) && !isCustomSelected
                                ? "border-[#079a95] bg-[#079a95]/5 text-[#079a95]"
                                : "border-[#e2e8f0] bg-white text-gray-700 hover:border-[#079a95]/50 hover:bg-[#079a95]/5"
                        }`}
                    >
                        <input
                            type="radio"
                            name={radioName}
                            value={option}
                            checked={selected.includes(option) && !isCustomSelected}
                            onChange={() => onChange([option], "")}
                            className="h-4 w-4 shrink-0 accent-[#079a95]"
                        />
                        <span className="font-medium">{option}</span>
                    </label>
                ))}
                <OtherRow
                    radioName={radioName}
                    isSelected={isCustomSelected}
                    customText={customText}
                    onSelect={() => onChange([CUSTOM_OPTION], customText)}
                    onTextChange={(text) => onChange([CUSTOM_OPTION], text)}
                />
            </div>
            <p className="text-xs text-gray-400">
                {selected.length === 0
                    ? "Select an option above, then click Continue"
                    : "Click Continue when you're ready"}
            </p>
        </>
    );
}
